import { createFileRoute } from '@tanstack/react-router'
import ClientsIndex from '@/pages/clients'

export const Route = createFileRoute('/_authenticated/clients/')({
  component: ClientsIndex,
})
